import _default from './Menu';
export { _default as default };